__turbopack_context__.v({
  "host": "Slots-module-scss-module__-FnILG__host",
  "hosts": "Slots-module-scss-module__-FnILG__hosts",
  "slotItem": "Slots-module-scss-module__-FnILG__slotItem",
  "slots": "Slots-module-scss-module__-FnILG__slots",
  "text": "Slots-module-scss-module__-FnILG__text",
  "title": "Slots-module-scss-module__-FnILG__title",
});
